import React, { FC, ReactNode, MouseEvent } from 'react';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { CHAT_MODAL_OVERLAY } from '../../../constants/qaAttributes';

interface IProps {
  children: ReactNode;
  offsetClick?: () => void;
}

const ChatModal: FC<IProps> = ({ children, offsetClick }) => {
  const event = (event: MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget && offsetClick) {
      offsetClick();
    }
  };

  return (
    <div className={css.chat__modal} onClick={event} {...setQaAttribute(CHAT_MODAL_OVERLAY)}>
      <div className={css.chat__modalContent}>{children}</div>{' '}
    </div>
  );
};

export default ChatModal;
